/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  /**
   * Fix for selected-color-value not updating when color swatch is selected
   * This patches the ProductForm class to properly update the color display
   */
  // Listen for option changes directly - no need to wait for theme
  document.addEventListener('change', function(event) {
    if (event.target && event.target.name && event.target.name.startsWith('options[')) {
      const target = event.target;
      const optionNameMatch = target.name.match(/options\[(.*?)\]/);
      if (!optionNameMatch) return;

      const selectedValue = target.value;
      const fieldset = target.closest('fieldset');
      if (!fieldset) return;

      const legend = fieldset.querySelector('legend');
      if (!legend) return;

      const selectedSpan = legend.querySelector('.selected-option-value');
      if (selectedSpan) {
        const cleanValue = selectedValue.replace(/^US /, '');
        selectedSpan.textContent = '(' + cleanValue + ')';
      }
    }
  });

  /**
   * Cart count badge – keeps [data-cart-count] badges in the header
   * in sync after add / update / remove operations.
   */
  function updateCartCountBadges() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var count = cart.item_count;
        document.querySelectorAll('.cart__toggle').forEach(function (toggle) {
          var badge = toggle.querySelector('[data-cart-count]');
          if (count > 0) {
            if (!badge) {
              badge = document.createElement('span');
              badge.className = 'cart__count';
              badge.setAttribute('data-cart-count', '');
              toggle.appendChild(badge);
            }
            badge.textContent = count;
          } else if (badge) {
            badge.remove();
          }
        });
      });
  }

  // After item added to cart
  document.addEventListener('theme:cart:added', updateCartCountBadges);

  // After quantity change or item removal inside the cart drawer
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-quantity-button]') || e.target.closest('[data-item-remove]')) {
      setTimeout(updateCartCountBadges, 600);
    }
  });

  /**
   * Buy-box info affordance -> scroll to an on-page section.
   * The wedge's ⓘ button carries [data-scroll-to="<anchor>"]; we scroll to the
   * matching [data-anchor="<anchor>"] section (e.g. the "How it works" band)
   * instead of opening a modal that duplicates it. No-ops if absent.
   */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-scroll-to]');
    if (!trigger) return;
    var name = trigger.getAttribute('data-scroll-to');
    var target = name && document.querySelector('[data-anchor="' + name + '"]');
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });

  /**
   * RebelsMarket — deliberate fit selection on made-to-fit footwear.
   *
   * Shopify falls back to `selected_or_first_available_variant` when no
   * ?variant= is present, which pre-selected the SMALLEST size and the
   * NARROWEST width (5.5 / B) on every made-to-fit product — manufacturing
   * wrong-size carts and returns on a product where a wrong size is a remake.
   *
   * product-option-value.liquid now clears the pre-selected Size (and defaults
   * Width to D), and buy-buttons.liquid renders Add to Cart disabled with
   * [data-rm-needs-size]. This keeps that state in sync as options are picked.
   *
   * Radios carry form="<product_form_id>", and the button lives inside that
   * form, so the two are matched via the form attribute rather than by
   * guessing a shared DOM ancestor.
   */
  (function rmFitRequired() {
    /**
     * Returns the names of option groups with no selection. Empty array means
     * every option is chosen and the button can be enabled.
     *
     * Checks every group, not just Size — an unselected option of any kind
     * means the form would submit with no resolvable variant id and fail at
     * Shopify.
     */
    function allOptionsChosenFor(button) {
      var form = button.form;
      if (!form) return [];
      // NOTE: `form.id` is unreliable here — the product form contains
      // <input name="id"> (the variant id), and HTMLFormElement named-property
      // lookup makes `form.id` return that INPUT instead of the id string.
      // getAttribute is the only safe read.
      var formId = form.getAttribute('id');
      if (!formId) return [];
      var selector = '[form="' + formId + '"]';
      var missing = [];
      var i;

      // Dropdown (popout) rendering keeps its value in a hidden input.
      var popouts = document.querySelectorAll('[data-popout-input]' + selector);
      for (i = 0; i < popouts.length; i++) {
        if (!popouts[i].value) missing.push(popouts[i].name || 'option');
      }

      // Group radios by option name; each group needs one checked input.
      var radios = document.querySelectorAll('input[type="radio"]' + selector);
      var groups = {};
      var order = [];
      for (i = 0; i < radios.length; i++) {
        var name = radios[i].name || '';
        if (!name) continue;
        if (!(name in groups)) {
          groups[name] = false;
          order.push(name);
        }
        if (radios[i].checked) groups[name] = true;
      }

      for (i = 0; i < order.length; i++) {
        if (!groups[order[i]]) missing.push(order[i]);
      }
      return missing;
    }

    // "Select your size" / "Select your width" — name the outstanding option
    // rather than a generic prompt, so the shopper knows what's missing.
    function labelFor(missingNames) {
      if (missingNames.length === 1) {
        var name = missingNames[0]
          .replace(/^options\[/, '')
          .replace(/\]$/, '')
          .toLowerCase();
        return 'Select your ' + name;
      }
      return 'Select your options';
    }

    function sync() {
      var buttons = document.querySelectorAll('[data-add-to-cart][data-rm-needs-size-label]');
      for (var i = 0; i < buttons.length; i++) {
        var button = buttons[i];
        var missing = allOptionsChosenFor(button);
        var slot = button.querySelector('.rm-needs-size-label');
        if (!missing.length) {
          button.removeAttribute('data-rm-needs-size');
          button.disabled = false;
        } else {
          button.setAttribute('data-rm-needs-size', '');
          button.disabled = true;
          if (slot) slot.textContent = labelFor(missing);
        }
      }
    }

    // Any option change anywhere re-evaluates; cheap and avoids depending on
    // the theme's own variant-change plumbing.
    document.addEventListener('change', function (event) {
      if (event.target && event.target.closest('variant-selects, [data-variant-buttons], popout-select')) {
        sync();
      }
    });

    // Quick view and section re-renders inject new forms after load.
    document.addEventListener('click', function () {
      window.setTimeout(sync, 300);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', sync);
    } else {
      sync();
    }
  })();

  /**
   * Stacked accessory upsell + options modal (ENG-167).
   * Cards: snippets/rm-custom-upsell-stack.liquid. Modal content:
   * sections/rm-custom-upsell-modal.liquid, fetched per product into one native
   * <dialog>. Every Add goes through the theme's own cart flow (theme:cart:add),
   * so the drawer refreshes and opens exactly as for the main Add to Cart.
   * Delegated on document because the cart drawer re-renders the cards after
   * every cart change.
   */
  (function () {
    var FORM = '[data-rm-upsell-form]';
    // Not the `disabled` attribute: the cart drawer re-enables every button it
    // contains after each refresh, so the "pick an option first" state is ours.
    var NEEDS_CHOICE = 'data-rm-needs-choice';
    var MODAL_SECTION = 'rm-custom-upsell-modal';
    // Shoe widths narrowest → widest; Shopify stores them in creation order.
    var WIDTH_ORDER = ['AA', 'A', 'B', 'C', 'D', 'E', 'EE', '2E', 'EEE', '3E', '4E', '5E', '6E'];

    var CARD = '[data-rm-upsell-card]';

    function addToCart(button) {
      document.dispatchEvent(new CustomEvent('theme:cart:add', { detail: { button: button }, bubbles: false }));
    }

    // ── Cards ─────────────────────────────────────────────────────────
    // Cards carry no <form> (on /cart they sit inside the cart form, and the
    // parser drops nested form tags). At click time the button is wrapped in a
    // script-built form holding just id + quantity: the DOM allows that nesting,
    // and the theme's cart flow reads FormData from button.closest('form').
    function cardForm(card, button, variantId) {
      var form = button.closest('form');
      if (!form || !form.classList.contains('rm-upsell__submit')) {
        form = document.createElement('form');
        form.className = 'rm-upsell__submit';
        form.action = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add';
        form.method = 'post';
        form.innerHTML = '<input type="hidden" name="id"><input type="hidden" name="quantity" value="1">';
        button.parentNode.insertBefore(form, button);
        form.appendChild(button);
      }
      form.querySelector('[name="id"]').value = variantId;
      return form;
    }

    document.addEventListener('change', function (event) {
      var input = event.target;
      if (!input.matches || !input.matches(CARD + ' input[data-rm-variant]')) return;
      var button = input.closest(CARD).querySelector('[data-rm-upsell-add]');
      if (button) button.toggleAttribute(NEEDS_CHOICE, !input.value);
    });

    document.addEventListener('click', function (event) {
      var button = event.target.closest ? event.target.closest('[data-rm-upsell-add]') : null;
      if (!button) return;
      event.preventDefault();
      var card = button.closest(CARD);
      var chosen = card.querySelector('input[data-rm-variant]:checked, input[type="hidden"][data-rm-variant]');
      if (!chosen) {
        var first = card.querySelector('input[data-rm-variant]');
        if (first) first.focus();
        return;
      }
      cardForm(card, button, chosen.value);
      addToCart(button);
    });

    // Modal form (a real <form>: the dialog lives on <body>, outside any cart form)
    document.addEventListener('submit', function (event) {
      var form = event.target.closest ? event.target.closest(FORM) : null;
      if (!form) return;
      event.preventDefault();
      var button = form.querySelector('[data-add-to-cart]');
      var id = form.querySelector('input[name="id"]');
      if (!button) return;
      if (!id || !id.value) {
        var first = form.querySelector('[data-rm-option] input[type="radio"]');
        if (first) first.focus();
        return;
      }
      addToCart(button);
    });

    // ── Modal ─────────────────────────────────────────────────────────
    var dialog = null;

    function getDialog() {
      if (dialog) return dialog;
      dialog = document.createElement('dialog');
      dialog.className = 'rm-upsell-modal';
      dialog.setAttribute('aria-label', 'Product options');
      // data-scroll-lock-scrollable: opened from the cart drawer, the theme's
      // scroll lock is active and cancels touch scrolling everywhere except
      // elements carrying this attribute (same one theme.wrap() sets).
      dialog.innerHTML =
        '<button type="button" class="rm-upsell-modal__close" data-rm-modal-close aria-label="Close">' +
        '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19" stroke="currentColor" stroke-width="1.5" fill="none"/></svg>' +
        '</button><div class="rm-upsell-modal__body" data-rm-modal-body data-scroll-lock-scrollable></div>';
      document.body.appendChild(dialog);
      // Backdrop click: the click lands on the <dialog> itself, outside its content
      dialog.addEventListener('click', function (event) {
        if (event.target === dialog || event.target.closest('[data-rm-modal-close]')) dialog.close();
      });
      // Unlock the page however the dialog closes (button, backdrop, Esc, cart added)
      dialog.addEventListener('close', function () {
        document.documentElement.classList.remove('rm-upsell-modal-open');
      });
      return dialog;
    }

    // Boot's current Size/Width on the product page, so the insole opens on it
    function selectionFromProductPage() {
      var picked = {};
      document.querySelectorAll('.product-single__wrapper input[name^="options["]:checked').forEach(function (input) {
        var match = input.name.match(/^options\[(.*)\]$/);
        if (match) picked[match[1]] = input.value;
      });
      return picked;
    }

    function prefillFor(trigger) {
      var holder = trigger.closest('[data-rm-prefill]');
      if (holder) {
        try { return JSON.parse(holder.getAttribute('data-rm-prefill')); } catch (e) { /* fall through */ }
      }
      return selectionFromProductPage();
    }

    // A few boots label options "US 11" or "D - Standard"; insoles use "11" / "D"
    function optionKey(value) {
      return String(value).replace(/^US\s+/i, '').replace(/\s+-\s+.*$/, '').trim().toUpperCase();
    }

    function sortTiles(container) {
      var tiles = Array.prototype.slice.call(container.children);
      var values = tiles.map(function (tile) { return tile.querySelector('input').value; });
      var numeric = values.every(function (v) { return /^\d+(\.\d+)?$/.test(v); });
      var widths = values.every(function (v) { return WIDTH_ORDER.indexOf(v) !== -1; });
      if (!numeric && !widths) return;
      tiles.sort(function (a, b) {
        var x = a.querySelector('input').value;
        var y = b.querySelector('input').value;
        return numeric ? parseFloat(x) - parseFloat(y) : WIDTH_ORDER.indexOf(x) - WIDTH_ORDER.indexOf(y);
      });
      tiles.forEach(function (tile) { container.appendChild(tile); });
    }

    function initModal(root, prefill) {
      var variantsEl = root.querySelector('[data-rm-modal-variants]');
      var variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
      var options = Array.prototype.slice.call(root.querySelectorAll('[data-rm-option]'));
      var idInput = root.querySelector('[data-rm-modal-variant]');
      var price = root.querySelector('[data-rm-modal-price]');
      var add = root.querySelector('[data-rm-modal-add]');
      var main = root.querySelector('[data-rm-modal-main]');

      options.forEach(function (fieldset) { sortTiles(fieldset.querySelector('[data-rm-option-tiles]')); });

      function selected() {
        return options.map(function (fieldset) {
          var checked = fieldset.querySelector('input:checked');
          return checked ? checked.value : null;
        });
      }

      function update() {
        var picks = selected();
        options.forEach(function (fieldset, i) {
          fieldset.querySelector('[data-rm-option-selected]').textContent = picks[i] ? ': ' + picks[i] : '';
          // Grey out values with no in-stock variant given the other picks
          fieldset.querySelectorAll('input').forEach(function (input) {
            var possible = variants.some(function (v) {
              return v.available && v.options.every(function (value, j) {
                return j === i ? value === input.value : (picks[j] === null || picks[j] === value);
              });
            });
            input.closest('label').classList.toggle('is-unavailable', !possible);
          });
        });
        if (!idInput) return;
        var complete = picks.every(function (p) { return p !== null; });
        var match = complete ? variants.find(function (v) {
          return v.options.every(function (value, j) { return value === picks[j]; });
        }) : null;
        idInput.value = match && match.available ? match.id : '';
        if (match) price.textContent = match.price;
        add.toggleAttribute(NEEDS_CHOICE, !idInput.value);
        add.textContent = match && !match.available
          ? add.getAttribute('data-label-sold-out')
          : add.getAttribute('data-label-add');
      }

      options.forEach(function (fieldset) {
        var name = fieldset.getAttribute('data-rm-option');
        var want = prefill && (prefill[name] || prefill[name.toLowerCase()]);
        if (want) {
          var input = Array.prototype.find.call(fieldset.querySelectorAll('input'), function (i) {
            return optionKey(i.value) === optionKey(want);
          });
          if (input) input.checked = true;
        }
        fieldset.addEventListener('change', update);
      });
      update();

      root.querySelectorAll('[data-rm-modal-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          if (main) { main.removeAttribute('srcset'); main.src = thumb.getAttribute('data-rm-modal-thumb'); }
          root.querySelectorAll('[data-rm-modal-thumb]').forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
        });
      });

      // Colour swatches are sibling products: reload the modal, keeping the picks
      root.querySelectorAll('[data-rm-modal-handle]').forEach(function (swatch) {
        swatch.addEventListener('click', function () {
          if (swatch.getAttribute('aria-current') === 'true') return;
          var keep = {};
          options.forEach(function (fieldset, i) {
            var pick = selected()[i];
            if (pick) keep[fieldset.getAttribute('data-rm-option')] = pick;
          });
          openModal(swatch.getAttribute('data-rm-modal-handle'), keep);
        });
      });
    }

    function openModal(handle, prefill) {
      var d = getDialog();
      var body = d.querySelector('[data-rm-modal-body]');
      body.innerHTML = '<p class="rm-upsell-modal__loading">Loading…</p>';
      if (!d.open) {
        d.showModal();
        document.documentElement.classList.add('rm-upsell-modal-open');
      }
      body.scrollTop = 0;
      var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
      fetch(root + 'products/' + encodeURIComponent(handle) + '?section_id=' + MODAL_SECTION)
        .then(function (response) {
          if (!response.ok) throw new Error(response.status);
          return response.text();
        })
        .then(function (html) {
          var wrapper = document.createElement('div');
          wrapper.innerHTML = html;
          var content = wrapper.querySelector('[data-rm-modal-product]');
          if (!content) throw new Error('missing content');
          body.innerHTML = '';
          body.appendChild(content);
          initModal(content, prefill);
        })
        .catch(function () {
          body.innerHTML = '<p class="rm-upsell-modal__loading">We couldn’t load the options. <a href="' +
            root + 'products/' + encodeURIComponent(handle) + '">Open the product page</a> instead.</p>';
        });
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest ? event.target.closest('[data-rm-upsell-open]') : null;
      if (!trigger) return;
      event.preventDefault();
      openModal(trigger.getAttribute('data-rm-upsell-open'), prefillFor(trigger));
    });

    // Close once the theme has added the item; its cart drawer takes over
    document.addEventListener('theme:cart:added', function () {
      if (dialog && dialog.open) dialog.close();
    });
  })();

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
